import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosInstance from '../../../axiosInstance';
import Swal from 'sweetalert2'; // Import SweetAlert2
import withReactContent from 'sweetalert2-react-content'; // Import React components for SweetAlert2

import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import LoadingTable from '../../components/LoadingTable';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import toast from "react-hot-toast";
import getDecryptData from '../../../helpers/getDecryptData';
import SlideButton from "react-slide-button";
import { useThemeContext } from '../../../fetchdata/ThemeContext';

const MySwal = withReactContent(Swal); // Create a SweetAlert2 instance with React components

function AllJob() {

const {dataAuth,getAuth} = useThemeContext();

    const [error, setError] = useState(null);

  const AcceptOrder = async (OrderId) => {
if(getAuth.verified === 0){
toast.error('Please Complete KYC First');
navigate('/profile/edit')
return;

}
       const decryptdatajson = await getDecryptData();

    let updatedFormData;

    updatedFormData = {
      OrderId,
      UserId: decryptdatajson._id,
    };

    console.log(updatedFormData);

    try { 

      await toast.promise(
        axiosInstance.post(`/admin/employee/accept-job`, updatedFormData),
        {
          loading: "Accept Job...", // Loading message
          success: "Accept Job successfully!", // Success message
          error: "Failed to Accept Job", // Error message
        }
      );
      fetchData();
     navigate('/pending-jobs');
      dataAuth();

    } catch (error) {
      console.error("Error On Added Lead:", error);
      console.log(formData);
      setError(error.response?.data?.message || "An unknown error occurred");
      toast.error(error.response.data.message);
      fetchData();
    }finally{
      // dataAuth();
    }
  };



   const [Dloading, setDLoading] = useState(true);
  const [getDriver, setDriver] = useState(false);
  const [AllDriver, setAllDriver] = useState([]);
  const [DriverId, setDriverId] = useState(null);
  const [OrderId, setOrderId] = useState(null);


  
  const handleDriverChange = (OrderId) => async (event) => {

    const DriverId = event.target.value;
    if (DriverId !== undefined) {
      setDriverId(DriverId);
    }


  };

  const selectDriver = async (OrderId, driver,cat,type,distance,empType) => {
    fetchemployeeData(cat,type,empType,distance);
    setOrderId(OrderId);
    setDriverId(driver);
   }

  const fetchemployeeData = async (cat,type,empType,distance) => {
    setAllDriver([]);
    try {

      const response = await axiosInstance.get(`/all-employee?type=${type}&longitude=${distance?.longitude || ''}&latitude=${distance?.latitude || ''}&empType=${empType}`);
      

      const { success, users } = response.data;
      if (success) {
        console.log('Users',response.data);

        setAllDriver(users);
       }

    } catch (error) {
      console.error('Error fetching Driver:', error);

    }

  };

  const handleClickDriverChange = async () => {
    setDLoading(true);
    try {
      const data = await axiosInstance.put(`/admin/update-employee-order/${OrderId}`, { agentId: DriverId });
      const { success } = data.data;
      if (success) {
        console.log(data)
        setDLoading(false);
        toast.success("Employee Updated success!");
      }


    } catch (error) {
      console.error('Error Updated Employee', error);
      setDLoading(false);
    } finally {
      fetchData();
    }
  }

  const handleClickAsignChange = async () => {
    setDLoading(true);
    try {
      const data = await axiosInstance.put(`/admin/update-employee-order/${OrderId}`, { asignId: DriverId });
      const { success } = data.data;
      if (success) {
        console.log(data)
        setDLoading(false);
        toast.success("Vendor Updated success!");
      }


    } catch (error) {
      console.error('Error Updated Vendor', error);
      setDLoading(false);
    } finally {
      fetchData();
    }
  }


  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setlimit] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');

  const [formData, setFormData] = useState({
    status: "",
  });

  const fetchData = async () => {

      const decryptdatajson = await getDecryptData();
      let employeeId = null;
        const id = decryptdatajson?._id;
       if(decryptdatajson.type === 1){
        employeeId = id
       }
    
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/admin/all-order?page=${currentPage}&limit=${limit}&search=${searchTerm}&status=${formData.status}&employeeId=${employeeId}&job=All`);
      setData(response.data.Order || []);
      setCurrentPage(response.data.currentPage);
      setTotalPages(response.data.totalPages);
      console.log(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
      setData([]);
    } finally {
      setLoading(false);
    }

  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, limit, formData]);

 
  

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };


  // Function to handle delete
  const handleDelete = (categoryId) => {
    MySwal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this data!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true,
      customClass: {
        popup: 'custom-swal-popup', // Add a class to the entire dialog
        confirmButton: 'btn-danger', // Add a class to the confirm button
      },
    }).then((result) => {
      if (result.isConfirmed) {


        axiosInstance.delete(`/admin/delete-order/${categoryId}`)
          .then(() => {
            // Refresh the data or update the state after successful deletion
            fetchData();
            toast.success("Deleting Ride success!");
          })
          .catch((error) => {
            console.error('Error deleting data:', error);
            toast.error("Error deleting data");
          });
      }
    });
  };


  const handleStatusChange = (ratingId) => async (event) => {
    const newStatus = event.target.value;
    setLoading(true);

    try {
      await axiosInstance.put(`/admin/update-order/${ratingId}`, { status: newStatus });
      setLoading(false);
      fetchData(currentPage);
      toast.success("Status Updated success!");
    } catch (error) {
      console.error('Error updating rating status:', error);
      setLoading(false);
    }

  };


  const handleLeadStatusChange = (statusId) => async (event) => {
    const newStatus = event.target.value;
    setLoading(true);

    try {
      await axiosInstance.put(`/admin/update-order/${statusId}`, { status: newStatus });
      setLoading(false);
      fetchData(currentPage);
      toast.success("Status Updated success!");
    } catch (error) {
      console.error('Error updating rating status:', error);
      setLoading(false);
    }

  };


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));

  };


  const inputRef = React.createRef();

  const handleSearchInputChange = (e) => {
    setCurrentPage(1);
    setTotalPages(1);
    setSearchTerm(e.target.value);
  };

  const handleSearch = () => {
    fetchData(currentPage);
  };

  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />
        <div className="py-4">


          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="mb-3 mb-lg-0">
              <h1 className="h4"> All Jobs</h1>
            </div>

          </div>
        </div>


        <div className="card">
          <div className="table-responsive py-4">

            {loading ? (
              <LoadingTable />
            ) : (
              <>


                <div className="datatable-top">
                  <div className="datatable-dropdown">
                    <label>
                      <select className="datatable-selector" value={limit} onChange={(e) => {
                        setlimit(parseInt(e.target.value, 10));
                        setCurrentPage(1); // Reset current page to 1 when the limit changes
                      }} >
                        <option value={5}>5</option>
                        <option value={10} >
                          10
                        </option>
                        <option value={15}>15</option>
                        <option value={20}>20</option>
                        <option value={25}>25</option>
                      </select>{" "}

                      entries per page
                    </label>
                  </div>

                  {/* <div className="datatable-dropdown">
                    <label>
                      Filter Status
                      <select className="datatable-selector mx-2" name="status" onChange={handleChange} value={formData.status}
                      >
                        <option value=" ">All Status</option>
                        <option value="0">Cancel</option>
                        <option value="1">Placed</option>
                        <option value="2">Accepted</option>
                        <option value="3">Packed</option>
                        <option value="4">Shipped</option>
                        <option value="5">Delivered</option>
                      </select>{" "}


                    </label>
                  </div> */}


                  <div className="d-flex align-items-center gap-2">
                    <div className="datatable-search">
                      <input
                        className="datatable-input"
                        type="text"
                        placeholder="Search...(By Ride ID)" value={searchTerm}
                        onChange={handleSearchInputChange}
                      />
                    </div>
                    <button className="btn btn-primary" onClick={handleSearch}> Search
                    </button>

                  </div>
                </div>

<div className='p-3'>


<div className='row'>

              {data.length !== 0 && data.map((row) => (
                <div className='col-md-6 mb-2' key={row._id} >
                <div className="card p-3 mb-2">
  <div className="d-flex m-0">
    <div className="media-body m-0">
      <h6 className="mt-2 mb-0">  {row?.details[0]?.username || "NA"}   </h6>
      <p className="small m-0 fw-light text-dark">
       {row?.items[0] ? row?.items[0].pickup  : "NA"}
      </p>
    </div>
  </div>
  <p className="fw-bold small m-0">  {row?.items[0]?.date? new Date(row?.items[0]?.date).toLocaleDateString('en-US', {
      weekday: 'short',
      day: '2-digit',
      month: 'short'
    }) : 'NA'} at {row?.items[0]?.time} </p>
  <hr />
  <div className=" justify-content-between">
    {/* <button type="button" className="btn btn-sm mb-2 me-2 btn-danger">
      Reject
    </button> */}

     <SlideButton
                        mainText={"Slide To Accept"}
                        overlayText={"Loading..."}
                        classList="my-class text-center startride w-80"
                        caretClassList="my-caret-class"
                        overlayClassList="my-overlay-class"
                        onSlideDone={() => AcceptOrder(row._id)}
                        hasError={!!error} // Pass error state to SlideButton
                      />

    {/* <button type="button" className="btn btn-sm mb-2 me-2 btn-primary">
      Accept <i className="ri-arrow-right-line ms-2" />
    </button> */}
  </div>
</div>

 
</div>
                    ))}
  
</div>

</div>
                <div className="datatable-bottom">
                  <div className="datatable-info">  </div>
                  <nav className="datatable-pagination">
                    <ul class="datatable-pagination-list">

                      <li className={`datatable-pagination-list-item ${currentPage === 1 ? 'datatable-hidden' : 'datatable-active'}`}>
                        <button data-page="1" class="datatable-pagination-list-item-link" onClick={handlePreviousPage} disabled={loading || currentPage === 1}
                          aria-label="Page 1">‹</button>
                      </li>
                      <li>
                        <div className="datatable-info py-1 px-3">Showing  Page{' '}
                          <strong>
                            Showing Page  {currentPage} of {totalPages}

                          </strong>{' '} </div>
                      </li>
                      <li className={`datatable-pagination-list-item ${currentPage === totalPages ? 'datatable-hidden' : 'datatable-active'}`}>
                        <button data-page="2" class="datatable-pagination-list-item-link" aria-label="Page 2" onClick={handleNextPage} disabled={loading || currentPage === totalPages}
                        >  {loading ? 'Loading...' : '›'} </button>
                      </li>
                    </ul></nav>
                </div>



              </>
            )}
          </div>
        </div>


        <div
              className="modal fade"
              id="modal-driver"
              tabIndex={-1}
              aria-labelledby="modal-driver"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">
                    <div className="mb-0">
                      <label htmlFor="eventTitle">
                      
                        Choose Employee
                      </label>{" "}

                      <select
                        className="form-control select"
                        name="status"
                        style={{ width: "100%" }} onChange={handleDriverChange(OrderId)}
                      >
                        <option > Select Employee</option>


                        {AllDriver.length > 0 ? (

                          AllDriver.map(driver => (
                            <option value={driver._id} key={driver._id} selected={driver._id === DriverId}
                            > {driver?.distance?.kilometers !== 0 && driver?.distance?.kilometers && 
                            <>
                           ( {driver?.distance?.kilometers} Km )
                            </>} {driver.username}</option>
                          ))
                        ) : (
                          <p>No Driver found.</p>
                        )}



                      </select>

                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      type="button"
                      data-bs-dismiss="modal" onClick={handleClickDriverChange}
                    >
                      Update Employee
                    </button>
                    <button
                      type="button"
                      className="btn btn-gray-300 ms-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>


            <div
              className="modal fade"
              id="modal-vendor"
              tabIndex={-1}
              aria-labelledby="modal-vendor"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">
                    <div className="mb-0">
                      <label htmlFor="eventTitle">
                      
                        Choose Vendor
                      </label>{" "}

                      <select
                        className="form-control select"
                        name="status"
                        style={{ width: "100%" }} onChange={handleDriverChange(OrderId)}
                      >
                        <option > Select Vendor</option>


                        {AllDriver.length > 0 ? (

                          AllDriver.map(driver => (
                            <option value={driver._id} key={driver._id} selected={driver._id === DriverId}
                            >{driver.username}</option>
                          ))
                        ) : (
                          <p>No Vendor found.</p>
                        )}



                      </select>

                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      type="button"
                      data-bs-dismiss="modal" onClick={handleClickAsignChange}
                    >
                      Update vendor
                    </button>
                    <button
                      type="button"
                      className="btn btn-gray-300 ms-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>


      </main>
    </>
  );
}

export default AllJob;
